import { EnvironmentProviders, inject, Provider } from '@angular/core';
import { IDENTITY_NOTIFIER, type IdentityNotifier } from '@lite-workspace/shared/identity';
import { ToastService } from '@lite-workspace/shared/helm-ui/toast';

import { provideVersionCheck } from '../version-check/version-check.provider';

export function provideVersionCheckToast(): (Provider | EnvironmentProviders)[] {
  return provideVersionCheck(service => {
    // Stays until answered: a missed update prompt leaves the user on a stale build.
    inject(ToastService).action('Доступно обновление', 'Обновить', () => service.forceReload(), 'info', 0);
  });
}

// The lib cannot reach a toast on its own — this adapter is what keeps a failed dismissal visible.
export function provideIdentityToastNotifier(): Provider {
  return {
    provide: IDENTITY_NOTIFIER,
    useFactory: (): IdentityNotifier => {
      const toast = inject(ToastService);
      return { notifyError: message => void toast.error(message) };
    },
  };
}
